'use client';

import { createContext, useContext, type ReactNode } from 'react';

import type { ServicePricesSearchInitialData } from '@/lib/service/servicePricesSearchInitialData';

const ServicePriceLookupInitialContext = createContext<ServicePricesSearchInitialData | null>(null);

export function ServicePriceLookupInitialProvider({
  children,
  value,
}: Readonly<{
  children: ReactNode;
  value: ServicePricesSearchInitialData | null;
}>): React.ReactNode {
  return (
    <ServicePriceLookupInitialContext.Provider value={value}>
      {children}
    </ServicePriceLookupInitialContext.Provider>
  );
}

export function useServicePriceLookupInitial(): ServicePricesSearchInitialData | null {
  return useContext(ServicePriceLookupInitialContext);
}
